import { ConcreteEncodable } from "./ConcreteEncodable";

import { CurrencyPairCalendarImplEncoder } from "../../encoder/CurrencyPairCalendarImplEncoder";

import * as CubiqTS from "../../index";
import { CurrencyPairCalendar } from "../CurrencyPairCalendar";

export class CurrencyPairCalendarImpl extends ConcreteEncodable implements CurrencyPairCalendar {
  public static enType: string = "com.bcdfx.model.calendar.CurrencyPairCalendarImpl";

  /*FID=1*/
  public baseCcy: string;
  /*FID=2*/
  public holidays: Array<CubiqTS.Holiday> | null = null;
  /*FID=3*/
  public nonBaseccy: string;
  /*FID=4*/
  public tenorToValueAndFixingDateSet: Array<CubiqTS.TenorToValueAndFixingDate> | null = null;
  /*FID=5*/
  public tenorToValueDateSet: Array<CubiqTS.TenorToValueDate> | null = null;
  /*FID=6*/
  public isNdfEnabled: boolean;
  /*FID=7*/
  public maxValueDate: CubiqTS.StandardDate | null = null;
  /*FID=8*/
  public tradeDateRollDate: CubiqTS.StandardDate | null = null;
  /*FID=9*/
  public tradeDateRollTime: CubiqTS.StandardTime | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CurrencyPairCalendarImplEncoder.Instance;
    this.setEncodableType(CurrencyPairCalendarImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CurrencyPairCalendarImpl[" +
      "baseCcy=" +
      this.baseCcy +
      "holidays=" +
      this.holidays +
      "nonBaseccy=" +
      this.nonBaseccy +
      "tenorToValueAndFixingDateSet=" +
      this.tenorToValueAndFixingDateSet +
      "tenorToValueDateSet=" +
      this.tenorToValueDateSet +
      "isNdfEnabled=" +
      this.isNdfEnabled +
      "maxValueDate=" +
      this.maxValueDate +
      "tradeDateRollDate=" +
      this.tradeDateRollDate +
      "tradeDateRollTime=" +
      this.tradeDateRollTime +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
